<template>
  <el-date-picker
    v-bind="$attrs"
    :picker-options="_pickerOptions"
    v-on="$listeners"
    :type="type"
  >
  </el-date-picker>
</template>
<script>
const DATE_RANGE_FULL = [
  {
    text: "最近15分钟",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 1000 * 60 * 15);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近30分钟",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 1000 * 60 * 30);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一小时",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一天",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一个月",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit("pick", [start, end]);
    },
  },
];

const DATE_RANGE_DATE = [
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一个月",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近三个月",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit("pick", [start, end]);
    },
  },
];

const DATE_DATE = [
  {
    text: "今天",
    onClick(picker) {
      picker.$emit("pick", new Date());
    },
  },
  {
    text: "昨天",
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);
      picker.$emit("pick", date);
    },
  },
  {
    text: "一周前",
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", date);
    },
  },
];

const DATE_FUTURE_DATE = [
  {
    text: "今天",
    onClick(picker) {
      picker.$emit("pick", new Date());
    },
  },
  {
    text: "明天",
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() + 3600 * 1000 * 24);
      picker.$emit("pick", date);
    },
  },
  {
    text: "一周后",
    onClick(picker) {
      const date = new Date();
      date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
      picker.$emit("pick", date);
    },
  },
];

const SHORTCUTS = {
  datetimerange: {
    full: DATE_RANGE_FULL,
    date: DATE_RANGE_DATE,
  },
  daterange: {
    date: DATE_RANGE_DATE,
  },
  date: {
    date: DATE_DATE,
    "future-date": DATE_FUTURE_DATE,
  },
};

export default {
  name: "CsDatePicker",
  props: {
    pickerOptions: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    shortcuts: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "datetimerange",
    },
  },
  computed: {
    _pickerOptions() {
      return Object.assign(
        {},
        this.convertShortcuts(this.shortcuts),
        this.pickerOptions
      );
    },
    _shortcutsData() {
      const g_shortcuts = this.$COMMONUI.shortcuts || {};
      const types = new Set([
        ...Object.keys(g_shortcuts),
        ...Object.keys(SHORTCUTS),
      ]);
      const res = {};
      for (let key of types) {
        res[key] = Object.assign({}, SHORTCUTS[key], g_shortcuts[key]);
      }
      return res;
    },
  },
  methods: {
    convertShortcuts() {
      const shortcuts = this.shortcuts;
      if (shortcuts) {
        if (Array.isArray(shortcuts)) {
          return shortcuts;
        } else {
          const type = this.type;
          return { shortcuts: this._shortcutsData[type]?.[shortcuts] };
        }
      } else {
        return undefined;
      }
    },
  },
};
</script>
